import { stringify } from 'query-string';

const queryParams = stringify({
  returnTo: process.env.NEXTAUTH_URL,
  client_id: process.env.AUTH_ZERO_CLIENT_ID,
});

export const HASURA_CLIENT_NAME = 'mttr-apps';
export const CALLBACK_URL = `https://${process.env.AUTH_ZERO_DOMAIN}/v2/logout?${queryParams}`;
